const MODULE = "Cruise";

const ACTIONS = {
  PAGE_CONTENT_CREATED: "Page Content Created",
  PAGE_CONTENT_UPDATED: "Page Content Updated"
};

export const MOBILE_LOG_TYPES = {
  MODULE,
  ACTIONS
};